export const site = {
  siteName: 'Grupo Majo',
  siteNameFull: 'Grupo Majo | Engenharia Civil & Soluções Técnicas',
  tagline: 'Projetos, laudos e soluções técnicas com responsabilidade e conformidade legal',
  motto: 'O sonho é seu, mas o trabalho é nosso.',
  logo: '/images/logo-grupo-majo.png',
  heroBadge: 'GRUPO MAJO • ENGENHARIA, PROCESSOS & INTERMEDIAÇÕES',
  contact: {
    whatsapp: '5511982561071',
    phoneDisplay: '(11) 98256-1071',
    email: 'engenharia.majo@gmail.com',
    coverage: 'Atendimento em todo o território nacional',
    cnpj: '56.392.209/0001-00',
    crea: '5071555749',
    technicalResponsible: 'Eng. Amilcar Sottani Faccion',
    linkedin: 'https://linkedin.com/in/amilcarfaccion',
  },
};

export const waUrl = (message) =>
  `https://wa.me/${site.contact.whatsapp}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_MESSAGE =
  'Olá, Eng. Amilcar! Acessei o site do Grupo Majo e gostaria de solicitar uma proposta técnica com emissão de ART.';

export const NAV_LINKS = [
  { path: '/', label: 'Início', short: 'Início', id: 'inicio' },
  { path: '/quem-somos', label: 'Quem Somos', short: 'Quem Somos', id: 'quemsomos' },
  { path: '/responsavel-tecnico', label: 'Responsável Técnico', short: 'Engenheiro', id: 'engenheiro' },
  { path: '/servicos', label: 'Áreas de Atuação', short: 'Atuação', id: 'servicos' },
  { path: '/pmp-empresas', label: 'PMP Empresarial', short: 'PMP', id: 'pmp' },
  { path: '/portfolio', label: 'Portfólio de Obras', short: 'Portfólio', id: 'portfolio' },
  { path: '/diferenciais', label: 'Diferenciais', short: 'Diferenciais', id: 'diferenciais' },
  { path: '/depoimentos', label: 'Depoimentos', short: 'Depoimentos', id: 'depoimentos' },
  { path: '/contato', label: 'Fale Conosco', short: 'Contato', id: 'contato' },
];

export const stats = [
  { end: 20, prefix: '+', suffix: ' anos', label: 'Experiência em obras e manutenção' },
  { end: 200, prefix: '+', suffix: '', label: 'Estabelecimentos comerciais, industriais, condomínios e residências' },
  { end: 100, prefix: '', suffix: '%', label: 'Serviços com ART registrada no CREA' },
  { text: 'Nacional', label: 'Atendimento e consultoria em todo o Brasil' },
];

export const normsMarquee = [
  'NBR 5410 — Instalações Elétricas',
  'NBR 5674 — Manutenção em Edificações',
  'NBR 13752 — Perícia de Engenharia',
  'NBR 16280 — Reformas em Edificações',
  'NBR 16747 — Inspeção Predial',
  'NBR 9050 — Acessibilidade',
  'NBR 6118 — Estruturas de Concreto',
  'NBR 15575 — Desempenho de Edificações',
  'NR-10 — Segurança em Eletricidade',
  'NR-18 — Construção Civil',
  'NR-35 — Trabalho em Altura',
  'ART registrada no CREA em 100% dos serviços',
];

export const services = [
  {
    id: 1,
    category: 'Projetos & Obras',
    name: 'Projetos e Execução de Obras',
    shortDescription: 'Do projeto à entrega de chaves com planejamento físico-financeiro rigoroso.',
    detailedDescription: 'Elaboração de projetos executivos, gestão de compras, acompanhamento diário e relatórios fotográficos com emissão de ART.',
    norms: ['NBR 16280', 'NBR 5674'],
    icon: 'drafting',
    demand: 'Execução/Reforma de Obra',
    image: 'https://images.unsplash.com/photo-1601074231509-dce351c05199?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 2,
    category: 'Documentação & Laudos',
    name: 'Emissão de ART (Anotação de Responsabilidade Técnica)',
    shortDescription: 'Responsabilidade técnica formal perante o CREA para condomínios, comércios e indústrias.',
    detailedDescription: 'Respaldo jurídico e conformidade com as regras de condomínios e prefeituras para obras de reforma, elétrica e estrutural. Acompanhamento técnico, fiscalização, consultoria e relatórios.',
    norms: ['Lei 6.496/77', 'CREA-SP'],
    icon: 'fileBadge',
    demand: 'Laudo Técnico / Vistoria',
    image: 'https://images.unsplash.com/photo-1772442198624-4fc4d7281e89?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 3,
    category: 'Documentação & Laudos',
    name: 'Laudos Técnicos e Vistorias Periciais',
    shortDescription: 'Pareceres técnicos fundamentados para fins judiciais, administrativos ou preventivos.',
    detailedDescription: 'Vistoria in loco, diagnóstico de não conformidades, registro fotográfico detalhado e soluções corretivas. Laudos de acessibilidade, estabilidade estrutural, segurança e habitabilidade, avaliação de danos e vícios ocultos.',
    norms: ['NBR 13752', 'NBR 16747'],
    icon: 'fileSearch',
    demand: 'Laudo Técnico / Vistoria',
    image: 'https://images.unsplash.com/photo-1774600166834-175d06febcd4?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 4,
    category: 'Manutenção & Diagnóstico',
    name: 'Inspeção Predial e Avaliação de Patologias',
    shortDescription: 'Identificação precoce de fissuras, infiltrações, recalques e desgaste estrutural.',
    detailedDescription: 'Classificação do grau de risco das manifestações patológicas, evitando custos com reformas ineficazes. Impermeabilizações, telhados e tratamento de patologias.',
    norms: ['NBR 16747'],
    icon: 'building',
    demand: 'Laudo Técnico / Vistoria',
    image: 'https://images.pexels.com/photos/8961008/pexels-photo-8961008.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
  {
    id: 5,
    category: 'Instalações',
    name: 'Projetos e Adequações de Instalações Elétricas',
    shortDescription: 'Projetos em baixa e média tensão, quadros de distribuição e laudos de SPDA.',
    detailedDescription: 'Dimensionamento seguro em conformidade com as normas vigentes, prevenindo sobrecargas e incêndios. Instalações elétricas e hidráulicas com conformidade NBR.',
    norms: ['NBR 5410', 'NR-10'],
    icon: 'zap',
    demand: 'Instalações Elétricas',
    image: 'https://images.pexels.com/photos/257736/pexels-photo-257736.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
  {
    id: 6,
    category: 'Segurança',
    name: 'Engenharia de Segurança do Trabalho',
    shortDescription: 'Programas de conformidade no canteiro de obras, PGR, PCMSO e treinamentos.',
    detailedDescription: 'Auditorias de segurança técnica, emissão de laudos de periculosidade/insalubridade e cumprimento das NRs.',
    norms: ['NR-10', 'NR-18', 'NR-35'],
    icon: 'hardHat',
    demand: 'Laudo Técnico / Vistoria',
    image: 'https://images.pexels.com/photos/8961065/pexels-photo-8961065.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
  {
    id: 7,
    category: 'Regularização',
    name: 'Regularização de Imóveis e Habite-se',
    shortDescription: 'Legalização cadastral, desdobro de lotes, aprovação de plantas e Habite-se junto às Prefeituras.',
    detailedDescription: 'Montagem completa de processos administrativos para emissão de alvarás de funcionamento e certidões imobiliárias.',
    norms: ['Legislação Municipal', 'Código de Obras'],
    icon: 'scale',
    demand: 'Regularização / Habite-se',
    image: 'https://images.pexels.com/photos/12955837/pexels-photo-12955837.jpeg?auto=compress&cs=tinysrgb&w=1600',
  },
  {
    id: 8,
    category: 'Arquitetura & Interiores',
    name: 'Arquitetura Corporativa, Drywall e Acabamentos',
    shortDescription: 'Divisórias acústicas, piso vinílico/elevado, forros termoacústicos e retrofit corporativo.',
    detailedDescription: 'Otimização de layouts corporativos integrando marcenaria sob medida, iluminação técnica e ergonomia. Projetos autorais, design de interiores completo e curadoria de materiais.',
    norms: ['NBR 15758'],
    icon: 'panels',
    demand: 'Projeto Executivo',
    image: 'https://images.unsplash.com/photo-1764410481612-7544525b2991?q=80&w=1600&auto=format&fit=crop',
  },
];

export const portfolio = [
  {
    title: 'Recepção Corporativa de Alto Padrão',
    category: 'Arquitetura & Retrofit',
    status: 'Concluído',
    scope: 'Painéis em madeira, bancada em pedra nobre, iluminação cênica e piso vinílico.',
    outcome: 'Espaço receptivo sofisticado alinhado à identidade visual da companhia.',
    image: '/images/works/obra-recepcao-corporativa.jpg',
  },
  {
    title: 'Sala de Diretoria Executiva com Boiserie',
    category: 'Design & Acabamento',
    status: 'Concluído',
    scope: 'Molduras de parede clássicas (boiserie), arandelas e tratamento de superfícies.',
    outcome: 'Ambiente executivo acolhedor com isolamento acústico adequado para negociações confidenciais.',
    image: '/images/works/obra-boiserie.jpg',
  },
  {
    title: 'Implantação de Pavimento Corporativo e Cabeamento',
    category: 'Infraestrutura & Facilities',
    status: 'Concluído',
    scope: 'Piso elevado com eletrocalhas, cabeamento estruturado e forros modulados.',
    outcome: 'Pavimento preparado para alta densidade de estações de trabalho e rápida manutenção.',
    image: '/images/works/obra-piso-elevado.jpg',
  },
  {
    title: 'Adequação de Acessibilidade e Rampa com Corrimão',
    category: 'Engenharia Civil & Acessibilidade',
    status: 'Concluído',
    scope: 'Rampa técnica com inclinação regulamentar, corrimão duplo em inox e portas de vidro.',
    outcome: 'Conformidade integral com a NBR 9050 e segurança para circulação de pedestres.',
    image: '/images/works/obra-rampa.jpg',
  },
  {
    title: 'Recepção Institucional com Identidade Aplicada',
    category: 'Arquitetura & Retrofit',
    status: 'Concluído',
    scope: 'Bancada em mármore, painéis escovados, letração iluminada e iluminação embutida.',
    outcome: 'Primeira impressão institucional à altura da marca, com materiais nobres e manutenção fácil.',
    image: '/images/works/obra-recepcao-institucional.jpg',
  },
  {
    title: 'Sala de Espera Executiva com Curadoria de Acabamentos',
    category: 'Arquitetura & Interiores',
    status: 'Concluído',
    scope: 'Poltronas em couro capitonê, tapete persa, painel de arte em azulejos e portas de vidro.',
    outcome: 'Ambiente de espera acolhedor e sofisticado, com zona de recepção valorizada.',
    image: '/images/works/obra-sala-espera.jpg',
  },
  {
    title: 'Recepção Institucional de Grande Porte',
    category: 'Arquitetura & Retrofit',
    status: 'Concluído',
    scope: 'Letreiro em alto-relevo iluminado, circulação ampla, poltronas estofadas e tapete persa.',
    outcome: 'Recepção de impacto institucional preparada para fluxo intenso de visitantes.',
    image: '/images/works/obra-recepcao-grande.jpg',
  },
  {
    title: 'Escritório Executivo com Boiserie e Mobiliário Sob Medida',
    category: 'Design & Acabamento',
    status: 'Concluído',
    scope: 'Mesa executiva em madeira, cadeiras em couro, boiseries, quadros e luminárias de parede.',
    outcome: 'Escritório de comando clássico e funcional, com isolamento visual e acústico.',
    image: '/images/works/obra-escritorio-executivo.jpg',
  },
  {
    title: 'Sala de Reuniões Executiva com Vista Panorâmica',
    category: 'Arquitetura & Interiores',
    status: 'Concluído',
    scope: 'Mesa de reunião com cadeiras executivas, luminotécnica e vidro com vista urbana.',
    outcome: 'Sala de reuniões pronta para apresentações, negociações e videoconferências.',
    image: '/images/works/obra-sala-reunioes.jpg',
  },
  {
    title: 'Corredor Executivo com Painéis Decorativos e Boiseries',
    category: 'Arquitetura & Acabamentos',
    status: 'Concluído',
    scope: 'Boiseries com molduras clássicas em painéis, arandelas duplas e acabamento acetinado.',
    outcome: 'Corredor corporativo com identidade clássica, acústica aprimorada e manutenção simplificada.',
    image: '/images/works/obra-sala-madeira.jpg',
  },
  {
    title: 'Sala de Reunião Clássica com Painéis em Madeira',
    category: 'Arquitetura & Acabamentos',
    status: 'Concluído',
    scope: 'Painéis em madeira, mesa de reunião ampla, cadeiras capitonê e TV para apresentações.',
    outcome: 'Sala formal e confortável para decisões estratégicas do dia a dia.',
    image: '/images/works/obra-sala-oval.jpg',
  },
  {
    title: 'Hall de Entrada com Curadoria de Antiguidades',
    category: 'Arquitetura & Interiores',
    status: 'Concluído',
    scope: 'Mobiliário clássico, esculturas, tapete persa e marcenaria de entrada sob medida.',
    outcome: 'Hall sofisticado com curadoria de peças de design e identidade atemporal.',
    image: '/images/works/obra-ambientes-antigos.jpg',
  },
  {
    title: 'Drywall, Forros e Infraestrutura Elétrica em Obra',
    category: 'Engenharia / Implantação de Projeto',
    status: 'Concluído',
    scope: 'Estrutura metálica de drywall, forro modulado, instalações elétricas e isolamento termoacústico.',
    outcome: 'Infraestrutura técnica pronta para receber os acabamentos finais do pavimento.',
    image: '/images/works/obra-implantacao-pavimento.jpg',
  },
];

export const pmp = {
  eyebrow: 'PMP para Empresas',
  title: 'Plano de Manutenção Preventiva para a sua empresa',
  intro:
    'Um programa contínuo de manutenção predial que reduz custos, evita paradas não programadas e valoriza o patrimônio — com equipe multidisciplinar, mapa de atendimento, relatórios fotográficos e ART registrada no CREA.',
  sla: 'SLA de até 36 horas para visitar o local e reparar ocorrências de Nível I',
  types: [
    { name: 'Preventiva', group: 'Manutenção Planejada', text: 'Rotinas programadas de inspeção e serviços que antecipam falhas e preservam os sistemas prediais.' },
    { name: 'Preditiva', group: 'Manutenção Planejada', text: 'Monitoramento técnico periódico para detectar sinais de desgaste antes que virem quebra.' },
    { name: 'Corretiva', group: 'Manutenção Não Planejada', text: 'Reparo ágil de falhas já identificadas, com priorização por criticidade da operação.' },
    { name: 'Imprevista', group: 'Manutenção Não Planejada', text: 'Atendimento de ocorrências urgentes dentro do SLA contratado, sem susto para o negócio.' },
  ],
  coverage: [
    { icon: 'zap', label: 'Elétrica' },
    { icon: 'droplets', label: 'Hidráulica' },
    { icon: 'brick', label: 'Alvenaria' },
    { icon: 'paintbrush', label: 'Pintura' },
    { icon: 'snowflake', label: 'Refrigeração e Ar-Condicionado' },
    { icon: 'layers', label: 'Gesso e Drywall' },
    { icon: 'network', label: 'TI e Redes' },
    { icon: 'wrench', label: 'Manutenção Geral' },
  ],
  steps: [
    { step: '01', title: 'Diagnóstico inicial', text: 'Inspeção predial conforme NBR 16747 e levantamento dos ativos críticos do imóvel.' },
    { step: '02', title: 'Mapa de atendimento', text: 'Plano anual com rotinas, responsáveis, janelas de serviço e SLA por nível de criticidade.' },
    { step: '03', title: 'Rotinas programadas', text: 'Execução das preventivas e preditivas com relatórios fotográficos e histórico técnico.' },
    { step: '04', title: 'Atendimento de chamados', text: 'Corretivas e imprevistas dentro do SLA, sempre com ART registrada no CREA.' },
  ],
  benefits: [
    { icon: 'piggy', title: 'Economia de custos', text: 'Manutenção programada custa menos que emergências e prolonga a vida útil dos ativos.' },
    { icon: 'trending', title: 'Valorização do patrimônio', text: 'Imóvel conservado vale mais e gera menos passivo de reformas corretivas.' },
    { icon: 'shield', title: 'Segurança', text: 'Ambientes em conformidade com normas reduzem riscos a pessoas e à operação.' },
    { icon: 'leaf', title: 'Ambientes eficientes', text: 'Sistemas revisados consomem menos energia e operam com desempenho estável.' },
    { icon: 'radar', title: 'Prevenção de problemas', text: 'Diagnósticos recorrentes evitam surpresas e interrupções do negócio.' },
  ],
};

export const testimonials = [
  {
    client: 'Marcelo Guimarães',
    role: 'Gerente de Facilities | Complexo Empresarial SP',
    service: 'Laudo Pericial e Adequação Elétrica',
    rating: 5,
    text: 'O Eng. Amilcar identificou não conformidades elétricas críticas que outras vistorias não apontaram. A ART foi emitida no mesmo dia e os laudos nos deram total respaldo perante o condomínio e a seguradora.',
  },
  {
    client: 'Renata Vasconcellos',
    role: 'Proprietária | Clínica Médica Integrada',
    service: 'Reforma e Regularização de Imóvel',
    rating: 5,
    text: 'Executamos nossa obra de 220 m² com o Grupo Majo sem nenhum estresse de prazo ou orçamento. A equipe domina tanto a parte civil quanto as normas de vigilância e prefeitura.',
  },
  {
    client: 'Carlos Eduardo Bittencourt',
    role: 'Síndico Profissional | Edifício Residencial e Comercial',
    service: 'Inspeção Predial e Plano de Manutenção (NBR 5674)',
    rating: 5,
    text: 'Rigor técnico impressionante. O relatório com fotos e diagnóstico das patologias evitou gastos emergenciais milionários em nossa fachada. Profissionais exemplares.',
  },
  {
    client: 'Patrícia Lemos',
    role: 'Gerente Hoteleira | Hotelaria Corporativa',
    service: 'Manutenção Predial Planejada e Retrofit',
    rating: 5,
    text: 'Manutenção predial planejada em operação 24h: a equipe manteve nossas unidades funcionando sem interromper a hospedagem. Diagnóstico técnico rápido e relatórios impecáveis.',
  },
  {
    client: 'Fernando Torres',
    role: 'Proprietário | Supermercado de Rede',
    service: 'Adequação de Instalações Elétricas (NBR 5410)',
    rating: 5,
    text: 'Adequaram o quadro de energia da loja sem fechar as portas nem um único dia. Zero sobrecargas desde então, e a ART nos deu segurança junto à seguradora.',
  },
  {
    client: 'Juliana Prado',
    role: 'Arquiteta Sócia | Estúdio de Interiores',
    service: 'Parceria Técnica em Projetos e Execução',
    rating: 5,
    text: 'Como arquiteta, sei o quanto é raro encontrar engenheiros que respeitam o detalhe do design. O Amilcar conduz a execução sem perder a estética nem o prazo.',
  },
];

export const videoTestimonials = [
  {
    client: 'Marcelo Guimarães',
    role: 'Gerente de Facilities | Complexo Empresarial SP',
    service: 'Laudo Pericial e Adequação Elétrica',
    youtubeId: null,
    thumb: 'https://static.prod-images.emergentagent.com/jobs/520de871-ab4b-483e-8479-8eb1f554b9a9/images/0d0f4399864a9526dacd09101f7de491a347370bc23ff4c40b530a8e6e8bf06e.jpeg',
  },
  {
    client: 'Renata Vasconcellos',
    role: 'Proprietária | Clínica Médica Integrada',
    service: 'Reforma e Regularização de Imóvel',
    youtubeId: null,
    thumb: 'https://static.prod-images.emergentagent.com/jobs/520de871-ab4b-483e-8479-8eb1f554b9a9/images/e4ea11fb581df696a56efb7be863c0e4f70090771950ebdd621ef800d4d0869e.jpeg',
  },
  {
    client: 'Carlos Eduardo Bittencourt',
    role: 'Síndico Profissional | Edifício Residencial e Comercial',
    service: 'Inspeção Predial e Plano de Manutenção (NBR 5674)',
    youtubeId: null,
    thumb: 'https://static.prod-images.emergentagent.com/jobs/520de871-ab4b-483e-8479-8eb1f554b9a9/images/176cfdcc842270a4c77259f0dfc0c362be1ab45e785c2cfd7425f6762019218d.jpeg',
  },
];

export const about = {
  title: 'Quem Somos',
  description: 'A Majo Processos e Intermediações transcende o conceito tradicional de reformas e construção civil: aliamos técnica, arte e funcionalidade em uma atuação multidisciplinar que integra engenharia civil, arquitetura e design de interiores — da fundação ao acabamento, do conceito ao detalhe.',
  narrative:
    'Com uma trajetória consolidada no setor da construção civil, somos especialistas em reformas prediais completas e na execução técnica de projetos, abrangendo elétrica, hidráulica, alvenaria, refrigeração e outros sistemas. A regra é entregar soluções inteligentes, seguras e com excelência técnica, com foco em durabilidade, funcionalidade e estética — sob medidas, sustentáveis, modernas e em plena conformidade com as normativas vigentes.',
  timeline: [
    { year: '2010', milestone: 'Fundação focada em infraestrutura e redes (Faccions Network).' },
    { year: 'Expansão', milestone: 'Consolidação da Majo Engenharia e Manutenção Predial.' },
    { year: 'Evolução', milestone: 'Criação da Majo Processos e Intermediações com atuação multidisciplinar.' },
    { year: 'Presente', milestone: 'Mais de 200 empresas atendidas em reformas, laudos, facilities e perícias técnicas pelo país.' },
  ],
  pillars: [
    { name: 'Missão', text: 'Oferecer soluções completas em engenharia, arquitetura e design de interiores, com foco em qualidade, inovação e segurança, transformando espaços em ambientes funcionais, estéticos e sustentáveis.' },
    { name: 'Visão', text: 'Ser referência nacional em projetos e execuções técnicas, reconhecida pela excelência, ética e criatividade na transformação de ambientes — a primeira escolha de quem busca profissionalismo, beleza e confiabilidade em cada detalhe.' },
    { name: 'Valores', text: 'Rigor técnico, inovação, transparência, ética profissional e o cliente no centro de cada decisão.' },
  ],
  values: [
    { name: 'Excelência Técnica', text: 'Rigor técnico e responsabilidade em cada projeto, respeitando normas, prazos e orçamentos.' },
    { name: 'Inovação e Criatividade', text: 'Engenharia aliada à sensibilidade do design, com soluções únicas, inteligentes e elegantes.' },
    { name: 'Comprometimento', text: 'Entregamos mais do que serviços — entregamos confiança, resultado e valor agregado.' },
    { name: 'Transparência', text: 'Comunicação clara, ética e honesta com clientes, parceiros e fornecedores.' },
    { name: 'Valorização Humana', text: 'Investimento no desenvolvimento da equipe e relacionamentos respeitosos e colaborativos.' },
    { name: 'Sustentabilidade', text: 'Soluções que respeitam o meio ambiente, com eficiência energética e práticas responsáveis.' },
    { name: 'Cliente no Centro', text: 'Projetamos com empatia, ouvindo, orientando e superando expectativas em cada etapa.' },
  ],
};

export const engineer = {
  name: 'Eng. Amilcar Sottani Faccion',
  title: 'Engenheiro Civil & Engenheiro de Segurança do Trabalho',
  crea: 'CREA-SP 5071555749',
  photo: '/images/eng-amilcar-faccion.jpg',
  bio: 'Profissional sênior com vivência na gestão de facilities, obras de retrofit corporativo e manutenção predial em complexos de grande porte em nível nacional. Mais de 20 anos conectando estratégia, operação e engenharia em operações multissite por todo o Brasil.',
  degrees: [
    'Engenharia Civil (UMESP)',
    'Pós-graduação em Engenharia de Segurança do Trabalho',
    'Pós-graduação em Engenharia de Manutenção',
    'Pós-graduação em Engenharia Elétrica (Sistemas de Potência e Instalações Industriais)',
    'MBA em Gestão de Obras, Qualidade e Desempenho das Construções',
    'Especialista em Arquitetura e Design de Interiores',
  ],
  certifications: ['NR-10', 'NR-18', 'NR-35', 'Perícia Judicial e Avaliação de Imóveis', 'BIM', 'Lean Construction'],
  systems: ['SAP PM', 'SAP MM', 'AutoCAD', 'Revit', 'MS Project', 'Power BI', 'Excel Avançado', 'ISO 14001', 'ISO 45001'],
  experience: [
    {
      period: '12/2025 — Atual',
      role: 'Planejador Estratégico de Manutenção, Facilities e Infraestrutura',
      company: 'Mars Brasil · Guararema/SP',
      highlight: 'Gestão de facilities em site com 10 prédios (~185.000 m²) e mais de 550 ativos críticos; redução de 56% no backlog de manutenção e 25% nos custos de contratos.',
    },
    {
      period: '06/2023 — 06/2025',
      role: 'Coordenador de Engenharia Civil, Infraestrutura e Facilities',
      company: 'MAJO Processos e Intermediações · São Bernardo do Campo/SP',
      highlight: 'Gestão simultânea de 2 a 5 obras (de 65 m² a 1.000 m²), equipes de 35 a 50 profissionais e investimentos de R$ 17 mil a mais de R$ 1 milhão.',
    },
    {
      period: '05/2021 — 05/2023',
      role: 'Coordenador Nacional de Infraestrutura, Engenharia e Facilities',
      company: 'Nelson Wilians Advogados · São Paulo/SP',
      highlight: 'Estruturação do departamento nacional e do Centro de Serviços Compartilhados; liderança de ~50 profissionais em 5 hubs regionais e ~30 contratos estratégicos.',
    },
    {
      period: '03/2020 — 03/2021',
      role: 'Supervisor de Operações',
      company: 'Treg Gás · São Paulo/SP',
      highlight: 'Gestão nacional de manutenção em mais de 250 estabelecimentos; melhoria de 75% no SLA de atendimento e treinamentos NR-01, NR-10 e NR-35.',
    },
    {
      period: '06/2017 — 03/2018',
      role: 'Encarregado de Manutenção Predial e Infraestrutura',
      company: 'Hotel Fazenda Hípica Atibaia · Atibaia/SP',
      highlight: 'Manutenção de propriedade com ~350.000 m², 15 unidades e mais de 550 ativos em operação 24h; redução de 50% no tempo de resposta.',
    },
  ],
};

export const differentials = [
  { icon: 'fileCheck', title: 'ART para 100% dos serviços', text: 'Toda intervenção nasce e termina com Anotação de Responsabilidade Técnica registrada no CREA — respaldo jurídico pleno para você, sua empresa e seu condomínio.' },
  { icon: 'graduation', title: 'Engenharia multidisciplinar sênior', text: 'Engenharia civil, segurança do trabalho, manutenção, elétrica, arquitetura e MBA em gestão de obras sob uma mesma responsabilidade técnica.' },
  { icon: 'shield', title: 'Conformidade normativa integral', text: 'Projetos, laudos e obras aderentes às normas ABNT (NBR 5410, 5674, 13752, 16280, 16747) e às NRs de segurança 10, 18 e 35.' },
  { icon: 'globe', title: 'Cobertura nacional', text: 'Mais de 200 estabelecimentos comerciais e industriais atendidos em reformas, laudos, facilities e perícias em todo o Brasil.' },
  { icon: 'layers', title: 'Soluções integradas', text: 'Civil, elétrica, hidráulica, HVAC, drywall, pintura e cabeamento estruturado — um único interlocutor técnico para toda a demanda.' },
  { icon: 'eye', title: 'Transparência total', text: 'Relatórios fotográficos, pareceres fundamentados e orçamentos claros do início ao fim da execução.' },
  { icon: 'handshake', title: 'Parceria de verdade', text: 'O sonho é seu, mas o trabalho é nosso: acompanhamento próximo e comunicação direta com o engenheiro responsável.' },
  { icon: 'timer', title: 'SLA definido de atendimento', text: 'Mapa de atendimento com SLA definido para priorizar e resolver com agilidade as ocorrências críticas do seu imóvel.' },
];

export const clientTypes = [
  { icon: 'building', label: 'Condomínios' },
  { icon: 'hotel', label: 'Hotéis' },
  { icon: 'cart', label: 'Supermercados' },
  { icon: 'utensils', label: 'Restaurantes e Padarias' },
  { icon: 'fuel', label: 'Postos de Combustível' },
  { icon: 'briefcase', label: 'Empresas Privadas' },
  { icon: 'factory', label: 'Indústrias' },
  { icon: 'home', label: 'Residências e Imobiliárias' },
];

export const demandTypes = [
  'Projeto Executivo',
  'Instalações Elétricas',
  'Execução/Reforma de Obra',
  'Laudo Técnico / Vistoria',
  'Regularização / Habite-se',
];

export const images = {
  hero: '/images/eng-amilcar-obra.jpg',
  facade: 'https://images.unsplash.com/photo-1637447032294-c3bbeada43f9?q=80&w=1600&auto=format&fit=crop',
  family: 'https://images.pexels.com/photos/8730055/pexels-photo-8730055.jpeg?auto=compress&cs=tinysrgb&w=1600',
  structure: 'https://images.unsplash.com/photo-1611816055460-618287c870bd?q=80&w=1600&auto=format&fit=crop',
  crane: 'https://images.unsplash.com/photo-1601074231509-dce351c05199?q=80&w=1600&auto=format&fit=crop',
  inspection: 'https://images.unsplash.com/photo-1774600166834-175d06febcd4?q=80&w=1600&auto=format&fit=crop',
  institutional: '/images/works/obra-recepcao-institucional.jpg',
};
